import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderMiradas } from "../../../components/Landing/Header/headerMiradas";
import { Footer } from "../../../components/Landing/Footer";
import { SEO } from "../../../components/SEO/SEO";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import festivalImage from "../../../assets/miradas/hero programacion 2026.jpg"
import banner2026 from "../../../assets/miradas/banner2026.png"
import { ExploraMiradas } from "../../../components/Landing/Miradas/ExploraMiradas";

/**
 * El documento de la programación, en Drive.
 *
 * Se guarda solo el identificador porque de él salen las dos direcciones: la
 * de la vista incrustada y la de abrir el archivo en Drive. Cambiar de
 * documento es cambiar esta línea.
 *
 * Para que la vista incrustada se vea, el archivo tiene que estar compartido
 * con cualquiera que tenga el enlace. Si queda restringido, a quien visite la
 * página le aparece el aviso de solicitar acceso.
 */
const PROGRAMACION_DRIVE_ID = "1wLEQyzcB1oddKrb8rdJz6ZY6q7-6sKxJ";

export const MiradasProgramacion = () => {
  const navigate = useNavigate();

  const handleNavigation = (route: string) => {
    navigate(route);
  };

  return (
    <>
      <SEO
        title="Programación de Miradas Medellín | Cine para todos"
        description="Miradas Medellín selecciona lo más reciente del cine iberoamericano, nacional y local a través de una programación que reúne nuevas voces, diversas formas de creación audiovisual y espacios de encuentro."
        keywords="programación Miradas Medellín, cartelera cine Medellín, agenda cultural Medellín, festival audiovisual 2026, cine iberoamericano, cine Medellín"
        ogTitle="Programación de Miradas Medellín"
        ogDescription="Miradas Medellín selecciona lo más reciente del cine iberoamericano, nacional y local a través de una programación que reúne nuevas voces y diversas formas de creación."
        ogImage={festivalImage}
        ogUrl={`${window.location.origin}/estimuloscultura/miradasProgramacion`}
      />
      <Header />
      <HeaderMiradas />
      <img src={banner2026} alt="Miradas Medellín 2026" style={{ width: "100%", height: "auto", objectFit: "cover" }} />

      {/* SECCIÓN 1: CABECERA Y TEXTOS */}
      <div className="container-fluid2" style={{ maxWidth: "1000px", margin: "0 auto", padding: "40px 20px" }}>
        <div className="font-family-Montserrat text-center font-color-black">
          <p className="mb-4" style={{ color: '#774747', fontSize: "16px" }}>
            El lugar de encuentro del <strong>nuevo cine iberoamericano</strong>
          </p>
          <h2 className="mb-4" style={{ fontWeight: "bold", fontSize: "28px", color: "#000" }}>
            Del 3 al 8 de noviembre de 2026 · Medellín, Colombia
          </h2>
          <h1 className="sr-only">Programación de Miradas Medellín</h1>

          <p className="mb-4" style={{ fontSize: "16px", textAlign: "justify" }}>
            Miradas Medellín selecciona lo más reciente del cine iberoamericano, nacional y local a través de una programación que reúne nuevas voces, diversas formas de creación audiovisual y espacios de encuentro entre las películas, sus creadores y las audiencias.
          </p>

          <div style={{ marginTop: "30px", marginBottom: "30px" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "15px" }}>Secciones de programación:</h3>
            <p style={{ fontSize: "16px", fontStyle: "italic", color: "#444" }}>
              Cine hecho en Medellín · Cine colombiano · Cine iberoamericano · Cine familiar · Cine accesible · Cine expandido · Miradas al Domo · Otros Ojos
            </p>
          </div>
        </div>
      </div>

      <div style={{ width: "100%" }}>
        <img src={festivalImage} alt="Público en el festival" style={{ width: "100%", height: "550px", objectFit: "cover" }} />
      </div>

      {/* SECCIÓN 2: PROGRAMACIÓN DEL FESTIVAL */}
      <div style={{ padding: "0 20px 60px 20px", display: "flex", justifyContent: "center", marginTop: "-5px" }}>
        <div style={{ backgroundColor: "#2d314a", color: "white", padding: "50px", maxWidth: "800px", width: "100%", borderRadius: "0 0 10px 10px" }}>
          <h2 style={{ color: "white", fontWeight: "bold", marginBottom: "20px", fontSize: "24px" }}>
            Programación del Festival de Cine y Artes Audiovisuales
          </h2>
          <p style={{ fontSize: "16px", marginBottom: "20px" }}>
            En 2026, Miradas Medellín ofrece una programación gratuita para encontrarnos alrededor del cine y las artes audiovisuales, con:
          </p>

          <ul style={{ fontSize: "16px", fontWeight: "bold", listStyleType: "none", paddingLeft: 0, marginBottom: "30px", lineHeight: "1.8" }}>
            <li>62 proyecciones cinematográficas</li>
            <li>2 conciertos</li>
            <li>4 muestras de cine expandido</li>
            <li>3 experiencias sonoras y visuales en el Domo</li>
            <li>4 laboratorios vivos</li>
            <li>6 conversatorios</li>
          </ul>

          <p style={{ fontSize: "16px", marginBottom: "30px" }}>
            Una programación para descubrir nuevas miradas, compartir experiencias y conectar con el cine iberoamericano, nacional y local.
          </p>

          <p style={{ fontSize: "16px", fontWeight: "bold" }}>
            Próximamente consulta la programación completa.
          </p>
        </div>
      </div>

      {/* SECCIÓN 3: DESCARGA LA PROGRAMACIÓN (general, va primero) */}
      <div style={{ padding: "40px 20px 80px 20px" }}>
        <div className="container-fluid2 text-center" style={{ maxWidth: "800px", margin: "0 auto", backgroundColor: "#e0e0e0", borderRadius: "10px", padding: "40px" }}>
          <h2 style={{ fontWeight: "bold", color: "black", fontSize: "24px", marginBottom: "20px" }}>
            Descarga la programación de Miradas Medellín 2026
          </h2>
          <p style={{ fontSize: "16px", marginBottom: "15px", color: "#333" }}>
            Consulta aquí la programación completa de Miradas Medellín 2026.
          </p>
          <p style={{ fontSize: "16px", marginBottom: "30px", color: "#333" }}>
            Aquí encontrarás las películas seleccionadas, horarios, sedes, invitados y todas las actividades que harán parte de esta nueva edición.
          </p>

          {/*
            La programación, para leerla sin salir de la página. Va sobre
            blanco porque el documento lo es, y con la altura en vh para que
            en un celular no ocupe una pantalla y media.
          */}
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              overflow: "hidden",
              marginBottom: "30px",
            }}
          >
            <iframe
              src={`https://drive.google.com/file/d/${PROGRAMACION_DRIVE_ID}/preview`}
              title="Programación de Miradas Medellín 2026"
              style={{ width: "100%", height: "70vh", minHeight: "420px", border: "none", display: "block" }}
              allow="autoplay"
            />
          </div>

          {/*
            El titulo de la seccion promete una descarga, asi que el boton la
            da. Es un enlace y no un Button con onClick para que el navegador
            lo trate como tal: abrir en otra pestaña, copiar la direccion.
          */}
          <Button
            type="primary"
            href={`https://drive.google.com/uc?export=download&id=${PROGRAMACION_DRIVE_ID}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '10px 30px', borderRadius: '5px' }}
          >
            Descargar la programación
          </Button>
        </div>
      </div>

      {/* SECCIÓN 4: PROGRAMACIÓN DE INDUSTRIA (va después de la general) */}
      <div style={{ padding: "40px 20px" }}>
        <div className="container-fluid2 text-center" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{ color: '#000', fontWeight: "bold", marginBottom: "20px", fontSize: "24px" }}>
            Programación de Industria
          </h2>
          <p style={{ fontSize: "16px", textAlign: "justify", marginBottom: "15px" }}>
            Miradas Medellín fortalece el ecosistema audiovisual a través de espacios de formación, desarrollo de proyectos y conexión profesional para nuevos talentos, realizadores y agentes del sector.
          </p>
          <p style={{ fontSize: "16px", textAlign: "justify", marginBottom: "30px" }}>
            Conoce la programación de industria con iniciativas como Talentos Miradas, el Encuentro de Coproducción y la Rueda de Negocios.
          </p>
          <Button
            type="primary"
            style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '10px 24px', borderRadius: '5px', whiteSpace: 'normal', maxWidth: '100%' }}
            onClick={() => handleNavigation('/miradasIndustria')}
          >
            Conoce la programación de Industria
          </Button>
        </div>
      </div>

      <ExploraMiradas />

      <Footer />
    </>
  );
};